import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { CheckCircle } from 'lucide-react';

// Tailwind needs literal class strings — explicit map per accent.
const ACCENT = {
  emerald: {
    bar: 'h-2 bg-emerald-500',
    iconBox: 'w-14 h-14 rounded-2xl bg-emerald-100 flex items-center justify-center mb-4',
    icon: 'w-7 h-7 text-emerald-600',
    thanksBox: 'w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4',
    thanksIcon: 'w-8 h-8 text-emerald-600',
    link: 'text-emerald-600 hover:underline',
  },
  amber: {
    bar: 'h-2 bg-amber-500',
    iconBox: 'w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center mb-4',
    icon: 'w-7 h-7 text-amber-600',
    thanksBox: 'w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4',
    thanksIcon: 'w-8 h-8 text-amber-600',
    link: 'text-amber-600 hover:underline',
  },
};

const FormCardShell = ({
  accent = 'emerald',
  icon: Icon,
  title,
  description,
  submitted,
  thankYouTitle,
  thankYouBody,
  contactCta,
  children,
}) => {
  const a = ACCENT[accent] || ACCENT.emerald;
  return (
    <Card className="shadow-xl border-0 bg-white overflow-hidden">
      <div className={a.bar} />
      <CardHeader className="pb-4">
        <div className={a.iconBox}>
          <Icon className={a.icon} />
        </div>
        <CardTitle className="text-2xl text-slate-900">{title}</CardTitle>
        <CardDescription className="text-slate-600 text-base">{description}</CardDescription>
      </CardHeader>
      <CardContent>
        {submitted ? (
          <div className="text-center py-8 px-4">
            <div className={a.thanksBox}>
              <CheckCircle className={a.thanksIcon} />
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">{thankYouTitle}</h3>
            <p className="text-slate-600">{thankYouBody}</p>
            <p className="text-sm text-slate-500 mt-4">
              {contactCta} <a href="mailto:info@dreamhousesusa.com" className={a.link}>info@dreamhousesusa.com</a>
            </p>
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
};

export default FormCardShell;
